module.exports = "//static.hsappstatic.net/marketplace-unified-public-base/static-1.1025/img/provider-ctas-blob-1x.png"